import React from "react";
import { ButtonHTMLAttributes } from "react";

interface TelefoneActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
}

export function TelefoneActionTexto({ text, ...rest }: TelefoneActionProps) {
  return <button {...rest}>{text}</button>;
}
